import React, {Component} from 'react';
import {Button, Card, Table} from "antd";
import {getSameNameAllNodes
} from "../actions/auditViewList";
import {connect} from "react-redux";
import {getAuditStorayList} from "../actions/auditStoryList";

class AuditStoryList extends Component {
    columns = [
        {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => (
                <a onClick={()=>this.showStory(record)}>{text}</a>
            ),
        },
        {
            title: '状态',
            dataIndex: 'statusName',
            key: 'statusName'
        },
        {
            title: '审核人',
            dataIndex: 'activitiAuditorNames',
            key: 'activitiAuditorNames',
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => (
                <span>
					<Button type="primary" onClick={()=>this.showStory(record)}>查看</Button>
				</span>
            ),
        }
    ];

    state = {
        data: []
    };

    showStory =(record) =>{
        let interviewId = record.interviewId || 0;
        let url = "/cm-sites/pms/addContribute/addContributeNews.html?interviewId=" + interviewId + "&eiditStoryId=" + record.id + "&currentMediaCode=" + record.mediaCode +"&actButtonId="+record.buttonId;
        window.openFull(url, "查看", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px',parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, ()=>window.location.search = new Date().getTime());
    };


    initDataSource = (page, pageSize) => this.paginationOnChange(page, pageSize);

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.currentUser.account){
            let {auditViewId, activitiType, mediaCode} = nextProps.match.params;
            getSameNameAllNodes(auditViewId, (data)=>{
                let nodeIds = [];
                data.map(item=>{
                    nodeIds.push(...item.nodeId.split(","));
                });

                const params = {
                    pojoName:activitiType,
                    ids:nodeIds,
                    queryMap:{mediaCode: mediaCode},
                    pageSize:10,
                    currentPage:0
                };
                getAuditStorayList(nextProps.currentUser.account, JSON.stringify(params), (res)=>{
                    this.setState({data: res.data})
                })
            })
        }
    }

    render() {
        const margin = 15;
        let pagination = {
            defaultCurrent: 1,
            defaultPageSize: 10,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
        };
        return (
            <Card title={<span style={{fontSize: "14px"}}>审核视角列表</span>} style={{ width: "calc(100% - "+margin*2+"px)", margin: margin + "px"}}>
                <Table columns={this.columns} dataSource={this.state.data} pagination={pagination}
                       bordered={true}//是否展示外边框和列边框
                       size={"small"}/>
            </Card>
        );
    }
}

function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser
    }
}

export default connect(mapStateToProps)(AuditStoryList);